import(/* webpackMode: "eager" */ "/home/u766677640/domains/aidaram.net/hbuilds/source/aidaram/src/app/daram/referral/page.tsx");
